module.exports = __webpack_public_path__ + "img/20wjhz-jpg png jpeg.20690d55.svg";